import styled from 'styled-components';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import { Spacings, TextColors } from '@styles/index';

const Loader = styled(CircularLoader)`
  margin-top: calc(50% - ${Spacings.SPACING_5B});
  margin-left: calc(50% - ${Spacings.SPACING_5B});
}
`;

const SupportPage = () => <Loader color={TextColors.BLUE} />;

SupportPage.Layout = ({ children }) => children;

export default SupportPage;
